<div class="tw-relative tw-flex tw-flex-col tw-gap-4 tw-rounded-t-6 tw-bg-white tw-px-6 tw-pb-6 tw-pt-9" [formGroup]="data.form">
  <div class="tw-absolute tw-left-1/2 tw-top-2 tw-h-1 tw-w-20 -tw-translate-x-1/2 tw-rounded-full tw-bg-gray-400 tw-opacity-20"></div>
  <div class="tw-flex tw-flex-col">
    <p class="tw-font-lexend tw-text-400 tw-font-bold tw-text-gray-800" i18n="@@addRemainingDetails">Add remaining details</p>
    <p class="tw-font-body tw-text-200 tw-text-gray-400" i18n="@@houseNumberHelpsDelivery">House number helps our delivery partner reach you</p>
  </div>
  <div class="tw-flex tw-flex-col tw-gap-2">
    <div class="tw-flex tw-flex-col tw-gap-1">
      <input class="tw-h-12 tw-w-full tw-rounded-xl tw-bg-gray-100 tw-font-body tw-text-300 tw-text-black tw-pl-4 tw-pr-4 tw-border-0 placeholder:tw-opacity-100 placeholder:tw-tracking-normal"
        #buildingInput
        id="remainingBuildingDetails"
        type="text"
        formControlName="buildingDetails"
        i18n-placeholder="@@houseNoBuildingName"
        placeholder="House no. / Building name"
        [class.tw-ring-1]="showBuildingRequired"
        [class.tw-ring-inset]="showBuildingRequired"
        [class.tw-ring-orange-500]="showBuildingRequired"
        [autocomplete]="true" />
      @if (showBuildingRequired) {
        <div id="remainingBuildingError" class="tw-flex tw-items-center">
          <div class="tw-text-orange-500 tw-text-200" i18n="@@errorHouse"> Please enter House No. or Building No. </div>
        </div>
      }
      @switch (buildingErrorType) {
        @case (ErrorType.NonEnglish) {
          <ng-container *ngTemplateOutlet="nonEnglishError"></ng-container>
        }
        @case (ErrorType.SpecialCharacters) {
          <ng-container *ngTemplateOutlet="specialCharactersError"></ng-container>
        }
        @case (ErrorType.MinCharLimit) {
          <div class="tw-flex tw-items-center tw-gap-1.5">
            <p i18n="@@errorBuildingDetailsMinChar" class="tw-text-orange-500 tw-text-200 tw-leading-none">House No. must be at least 3 characters long</p>
          </div>
        }
      }
    </div>
    <div class="tw-flex tw-flex-col tw-gap-1">
      <input class="tw-h-12 tw-w-full tw-rounded-xl tw-bg-gray-100 tw-font-body tw-text-300 tw-text-black tw-pl-4 tw-pr-4 tw-border-0 placeholder:tw-opacity-100 placeholder:tw-tracking-normal"
        #localityInput
        id="remainingLocalityDetails"
        type="text"
        formControlName="localityDetails"
        i18n-placeholder="@@areaRoadName"
        placeholder="Area / Road name"
        [class.tw-ring-1]="showLocalityRequired"
        [class.tw-ring-inset]="showLocalityRequired"
        [class.tw-ring-orange-500]="showLocalityRequired"
        [autocomplete]="true" />
      @if (showLocalityRequired) {
        <div id="remainingLocalityError" class="tw-flex tw-items-center">
          <div class="tw-text-orange-500 tw-text-200" i18n="@@errorArea"> Please enter area or colony name </div>
        </div>
      }
      @switch (localityErrorType) {
        @case (ErrorType.NonEnglish) {
          <ng-container *ngTemplateOutlet="nonEnglishError"></ng-container>
        }
        @case (ErrorType.SpecialCharacters) {
          <ng-container *ngTemplateOutlet="specialCharactersError"></ng-container>
        }
        @case (ErrorType.MinCharLimit) {
          <div class="tw-flex tw-items-center tw-gap-1.5">
            <p i18n="@@errorLocalityDetailsMinChar" class="tw-text-orange-500 tw-text-200 tw-leading-none">Area name must be at least 5 characters long</p>
          </div>
        }
      }
    </div>
    <div class="tw-flex tw-flex-col tw-gap-1">
      <input class="tw-h-12 tw-w-full tw-rounded-xl tw-bg-gray-100 tw-font-body tw-text-300 tw-text-black tw-pl-4 tw-pr-4 tw-border-0 placeholder:tw-opacity-100 placeholder:tw-tracking-normal"
        id="remainingLandmark"
        type="text"
        formControlName="landmark"
        i18n-placeholder="@@nearbyLandmarkOptional"
        placeholder="Nearby landmark (optional)"
        [autocomplete]="true" />
      @if (landmarkErrorType) {
        <div id="remainingLandmarkError">
          @switch (landmarkErrorType) {
            @case (ErrorType.NonEnglish) {
              <ng-container *ngTemplateOutlet="nonEnglishError"></ng-container>
            }
            @default {
              <ng-container *ngTemplateOutlet="specialCharactersError"></ng-container>
            }
          }
        </div>
      }
    </div>
  </div>
  <button csButton id="saveRemainingDetails" type="button" class="tw-w-full" (click)="save()">
    <span i18n="@@saveAddressCta">Save Address</span>
  </button>
</div>

<ng-template #nonEnglishError>
  <div class="tw-flex tw-items-center tw-gap-1.5">
    <p i18n="@@errorNonEnglishAddress" class="tw-text-orange-500 tw-text-200 tw-leading-none">Please enter address in English language only</p>
  </div>
</ng-template>

<ng-template #specialCharactersError>
  <div class="tw-flex tw-items-center tw-gap-1.5">
    <p i18n="@@errorSpecialCharacters" class="tw-text-orange-500 tw-text-200 tw-leading-none">Please avoid using special characters and emojis</p>
  </div>
</ng-template>
